import axios from "axios";
import moment from "moment";
import { splitTeacherCourses } from "@/utils/teacherCourseSeparator";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      pendingRefundApplyList: [],
      studentList: [],
      oriStudentList: [],
      studentNames: {},
      classList: [],
      oriClassList: [],
      classNames: {},
      classType: {},
      teacherList: [],
      teacherNames: {},
      showRefundDetail: false,
      selectedPendingIndex: 0,
      refundRealFee: 0,
      refundServiceFee: 0,
      refundTotalFee: 0,
      selectedRefundRemainingTotal: 0,
      selectedRefundDonateAmount: 0,
      refundClassCourseTecherFeeObj: {},
      useOriFee: 0
    };
  },
  async mounted() {
    await this.getStudentList();
    await this.getClassList();
    await this.getTeacherList();
    await this.getRefundApprovalList();
  },
  methods: {
    // 获取退费申请 待审批列表
    async getRefundApprovalList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getPendingRefundApply", params);
        if (resp1.data.code == "0000") {
          this.pendingRefundApplyList = resp1.data.data;

          // 格式化时间
          for (let i in this.pendingRefundApplyList) {
            this.pendingRefundApplyList[i].create_time = moment(this.pendingRefundApplyList[i].create_time).format("YYYY-MM-DD HH:mm:ss");
            this.pendingRefundApplyList[i].update_time = moment(this.pendingRefundApplyList[i].update_time).format("YYYY-MM-DD HH:mm:ss");
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取学生列表
    async getStudentList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/getStudentList", params);
        if (resp1.data.code == "0000") {
          this.studentList = resp1.data.data;

          // console.log("获取学生列表:", this.studentList);

          this.oriStudentList = JSON.parse(JSON.stringify(this.studentList));
          this.studentNames = {};
          for (let i in this.studentList) {
            this.studentNames[this.studentList[i].id] = this.studentList[i].name;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取班级列表
    async getClassList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/courseArrange/getClassList", params);
        if (resp1.data.code == "0000") {
          this.classList = resp1.data.data;

          // 部分字段json.parse()
          for (let i in this.classList) {
            this.classList[i].teacherIds = JSON.parse(this.classList[i].teacherIds);
            // 将 teacherId 倒序排列
            this.classList[i].teacherIds.sort((a, b) => b - a);
            this.classList[i].courses = JSON.parse(this.classList[i].courses);
            this.classList[i].periods = JSON.parse(this.classList[i].periods);
          }
          this.oriClassList = JSON.parse(JSON.stringify(this.classList));

          // console.log("获取班级列表 this.classList:", this.classList);

          // classId转换为className
          for (let i = 0; i < this.classList.length; i++) {
            this.classNames[this.classList[i].id] = this.classList[i].name;
            this.classType[this.classList[i].id] = this.classList[i].courseType;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    //获取老师列表(筛选出启用的)
    async getTeacherList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution,
          flag: "onlyActive" //(筛选出启用的)
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/getTeacherList", params);
        if (resp1.data.code == "0000") {
          this.teacherList = resp1.data.data;
          for (let i in this.teacherList) {
            this.teacherList[i].courses = splitTeacherCourses(this.teacherList[i].coursesStr);
          }

          // console.log("获取老师列表 this.teacherList:", this.teacherList);

          this.teacherNames = {};
          for (let i = 0; i < this.teacherList.length; i++) {
            this.teacherNames[this.teacherList[i].id] = this.teacherList[i].name;
          }
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 查看退费详情
    seeRefundDetail(index) {
      this.refundClassCourseTecherFeeObj = JSON.parse(this.pendingRefundApplyList[index].refundClassCourseTecherFeeObj);
      this.selectedRefundRemainingTotal = 0;
      for (const classItem of Object.values(this.refundClassCourseTecherFeeObj)) {
        for (const courseItem of Object.values(classItem)) {
          for (const teacherItem of Object.values(courseItem)) {
            for (const feeItem of Object.values(teacherItem)) {
              const remainingAmount = feeItem.remainingAmount != null ? Number(feeItem.remainingAmount) || 0 : (Number(feeItem.refundFee) || 0) + (Number(feeItem.donateAmount) || 0);
              this.selectedRefundRemainingTotal += remainingAmount;
            }
          }
        }
      }
      this.selectedRefundRemainingTotal = parseFloat(this.selectedRefundRemainingTotal.toFixed(2));
      this.selectedRefundDonateAmount = parseFloat(Math.max(0, this.selectedRefundRemainingTotal - Number(this.pendingRefundApplyList[index].refundTotalFee)).toFixed(2));
      console.log("this.refundClassCourseTecherFeeObj:", this.refundClassCourseTecherFeeObj);
      this.useOriFee = this.pendingRefundApplyList[index].useOriFee;
      this.selectedPendingIndex = index;
      this.showRefundDetail = true;
    },
    cancelRefundDetail() {
      this.showRefundDetail = false;
    },
    // 退费审批通过
    async approveRefund() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          refundApplyId: this.pendingRefundApplyList[this.selectedPendingIndex].id
        };
        let resp1 = await axios.post("https://backend.wonology.com/enrollAndClear/studentManagement/approveRefundApply", params);
        if (resp1.data.code == "0000") {
          this.showRefundDetail = false;
          await this.getRefundApprovalList();

          // 调用App.vue 的 refundApproval对应的方法，更新退费审批的数字
          // <router-view>中加 @refundApproval="refundApproval"
          this.$emit("refundApproval");
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    }
  }
};